import { render, staticRenderFns } from "./dictSelect.vue?vue&type=template&id=71d86870&scoped=true"
import script from "./dictSelect.vue?vue&type=script&lang=js"
export * from "./dictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d86870",
  null
  
)

export default component.exports